import React, { useState } from 'react';
import { ItemsList } from './ItemsList';
import { ItemDetails } from './ItemDetails';
import { ItemsDto } from '../../../../types/items';
import { useTranslation } from '../../../../contexts/I18nProvider';

interface ItemAdminProps {
  onBack?: () => void;
}

export const ItemAdmin: React.FC<ItemAdminProps> = ({ onBack }) => {
  const { t } = useTranslation();
  const [selectedItem, setSelectedItem] = useState<ItemsDto | null>(null);

  const handleItemSelect = (item: ItemsDto) => {
    setSelectedItem(item);
  };

  const handleBackToList = () => {
    setSelectedItem(null);
  };

  return (
    <div className="min-h-full">
      {selectedItem ? (
        <ItemDetails item={selectedItem} onBack={handleBackToList} />
      ) : (
        <ItemsList onItemSelect={handleItemSelect} onBack={onBack} />
      )}
    </div>
  );
};
